/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import './App.scss'
import { createHashRouter, RouterProvider } from 'react-router-dom'
import Home from './pages/home'
import SidePanel from './pages/sidePanel'

const router = createHashRouter([
  {
    path: '/sidePanel',
    element: <SidePanel />
  },
  {
    path: '/',
    element: <Home />
  }
])

export default function MyApp() {
  return (
    <div className="main-app-wrapper" data-testid="main-app-wrapper">
      <RouterProvider router={router} />
    </div>
  )
}
